import { Injectable } from '@angular/core';
import { ProcessStepName } from '@common/analytics/model/process-step';
import { RegistrationBase } from '@common/model/registration.base';
import { AuctionService } from '@common/services/auction.service';
import { RegisterFlowLocationService } from '@common/services/register-flow-location.service';
import {
    ProcessStepData,
    ProcessStepServiceBase,
} from '@common/analytics/services/process-step.service.base';

@Injectable()
export class ProcessStepService extends ProcessStepServiceBase {
    data: ProcessStepData = {
        interestedIndividualFlow: {
            person: [
                'personal details',
                'interested individual confirmed',
            ],
            product: null,
        },
        registrationFlow: {
            person: [
                'personal details - minimal',
                'personal details - address',
                'product details',
                'registration completed', 
                'email confirmed'
            ],
            product: null,
        },
        decisionFlow: {
            person: [
                'personal details - minimal',
                'personal details - address',
                'product details',
                'registration completed',
                'proposal',
                'decided',
            ],
            product: null,
        },
    };

    constructor(private flowLocationService: RegisterFlowLocationService) {
        super();
    }

    getActiveStep<T extends RegistrationBase>(
        registration: T,
    ): ProcessStepName {
        const isInterestedIndividual = !AuctionService.getAnyAuction(
            registration,
            registration.community,
        );
        switch (this.flowLocationService.activeStep) {
            case 'minimal':
                return 'personal details - minimal';
            case 'person':
                return 'personal details - address';
            case 'product':
                return 'product details'; 
            case 'offer-introduction':
                return 'registration completed';
            case 'proposal':
                return 'proposal';
            case 'overview':
                if (isInterestedIndividual)
                    return 'interested individual confirmed'; 
                if (registration?.emailConfirmed) return 'email confirmed';
                if (registration?.decisionComplete) return 'decided';
                if (registration?.subscriptionComplete)
                    return 'registration completed';
        }
    }
}
